import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_2 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_3 = { class: "flex gap-3 mb-2" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_6 = { class: "flex flex-wrap gap-2" }
const _hoisted_7 = { class: "text-sm font-medium" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 1,
  class: "text-sm text-red-600 mt-1"
}

import { ref, watch } from 'vue';
import ActionButton from '@/components/ui/ActionButton.vue';
import type { BrandSelectorFieldProps } from '@/types/sellerRegister';


export default /*@__PURE__*/_defineComponent({
  __name: 'BrandSelectorField',
  props: {
    label: {},
    required: { type: Boolean, default: false },
    placeholder: { default: 'Saisir une marque...' },
    modelValue: {},
    gridClass: { default: '' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// État local
const newBrand = ref('');
const selectedBrands = ref<string[]>([]);
const error = ref('');

// Initialiser avec la valeur du modèle
watch(() => props.modelValue, (newValue) => {
  selectedBrands.value = [...newValue];
}, { immediate: true });

// Ajouter une marque
const addBrand = () => {
  const brand = newBrand.value.trim();
  
  if (!brand) {
    error.value = 'Veuillez saisir une marque';
    return;
  }
  
  // Vérifier si la marque existe déjà
  if (selectedBrands.value.includes(brand)) {
    error.value = 'Cette marque est déjà sélectionnée';
    return;
  }
  
  // Ajouter la marque
  selectedBrands.value.push(brand);
  newBrand.value = '';
  error.value = '';
  
  // Émettre la mise à jour
  emit('update:modelValue', [...selectedBrands.value]);
};

// Supprimer une marque
const removeBrand = (index: number) => {
  selectedBrands.value.splice(index, 1);
  emit('update:modelValue', [...selectedBrands.value]);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.gridClass)
  }, [
    _createElementVNode("label", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
      (_ctx.required)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newBrand).value = $event)),
        type: "text",
        placeholder: _ctx.placeholder,
        class: "flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors",
        onKeyup: _withKeys(addBrand, ["enter"])
      }, null, 40, _hoisted_4), [
        [_vModelText, newBrand.value]
      ]),
      _createVNode(ActionButton, {
        variant: "primary",
        size: "sm",
        label: "Ajouter",
        icon: "fas fa-plus",
        disabled: !newBrand.value.trim(),
        onClick: addBrand,
        class: "whitespace-nowrap"
      }, null, 8, ["disabled"])
    ]),
    (selectedBrands.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedBrands.value, (brand, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "flex items-center gap-2 px-3 py-1 bg-blue-50 text-blue-700 rounded-lg border border-blue-200"
              }, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(brand), 1),
                _createElementVNode("button", {
                  type: "button",
                  onClick: ($event: any) => (removeBrand(index)),
                  class: "text-blue-500 hover:text-blue-700 transition-colors",
                  title: "Supprimer cette marque"
                }, _cache[1] || (_cache[1] = [
                  _createElementVNode("i", { class: "fas fa-times text-xs" }, null, -1)
                ]), 8, _hoisted_8)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (error.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(error.value), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})